module.exports = __webpack_public_path__ + "img/logo.8a1b3ef7.png";